import { render } from "./easyEarn.vue?vue&type=template&id=4f15a659&scoped=true"
import script from "./easyEarn.vue?vue&type=script&lang=js"
export * from "./easyEarn.vue?vue&type=script&lang=js"

import "./easyEarn.vue?vue&type=style&index=0&id=4f15a659&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f15a659"]])

export default __exports__